import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { UserRole } from '../../types/portal';
import StudentProfile from './StudentProfile';
import TeacherProfile from './TeacherProfile';
import AdminProfile from './AdminProfile';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: #ffffff;
`;


const UnifiedProfile: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { t } = useTranslation();

  if (!user) {
    return null; // ProtectedRoute should prevent this case
  }

  let content: React.ReactNode;
  switch (user.role) {
    case UserRole.STUDENT:
      content = <StudentProfile />;
      break;
    case UserRole.TEACHER:
      content = <TeacherProfile />;
      break;
    case UserRole.ADMIN:
      content = <AdminProfile />;
      break;
    default:
      content = <div style={{ padding: '1rem' }}>{t('portal.profile.unknown_role')}</div>;
  }

  return (
    <PageWrapper>
      <div>
        <div>
          <div style={{ marginBottom: '1rem' }}>
          </div>
          {content}
        </div>
      </div>
    </PageWrapper>
  );
};

export default UnifiedProfile;
